import { render } from "./QcFormBuilderTemplate.vue?vue&type=template&id=1b4661f8&scoped=true"
import script from "./QcFormBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./QcFormBuilderTemplate.vue?vue&type=script&lang=js"

import "./QcFormBuilderTemplate.vue?vue&type=style&index=0&id=1b4661f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4661f8"]])

export default __exports__